import styled from "styled-components";
import {
  deviceHeight,
  deviceMinWidth,
  deviceMaxWidth,
} from "../MediaQueries";

export const StyledNonAuthHeader = styled.header`
  position: fixed;
  width: 100%;
  height: 70px;
  left: 0;
  top: 0;
  background: #fff;
  box-shadow: 0 4px 13px rgba(0, 0, 0, 0.05);
  z-index: 99;
  align-items: center !important;
  display: flex !important;

  .flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }

  .justify-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }

  .align-center {
    -ms-flex-align: center !important;
    align-items: center !important;
  }

  .column--100 {
    width: 100%;
  }

  .kuda-header--wrap {
    max-width: 1500px;
    margin: 0 auto;
    display: block;
    padding-left: 60px;
    padding-right: 60px;

    .kuda-brand svg {
      height: 20px;
      width: auto;

      @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1440} and ${deviceHeight.breakpoint798} {
        height: 18px;
        width: auto;
      }
      @media only screen and ${deviceMaxWidth.breakpoint767} {
        height: 16px;
      }
      @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1280} and ${deviceHeight.breakpoint698} {
        height: 16px;
        width: auto;
      }
      @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1024} {
        height: 18px;
        width: auto;
      }
    }
    .kuda-cta {
      font-size: 15px;
      height: 46px;
      border: 1px solid var(--primaryAlt);
      width: 175px;
      max-width: 175px;

      @media only screen and ${deviceMaxWidth.breakpoint350} {
        font-size: 13px;
        height: 42px;
        width: 100%;
      }

      @media only screen and ${deviceMaxWidth.breakpoint320} {
        font-size: 12px;
        width: 131px;
        margin-top: 15px;
        max-width: 100%;
      }

      @media only screen and ${deviceMaxWidth.breakpoint375} {
        font-size: 13px;
        width: 140px;
      }

      @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1280} and ${deviceHeight.breakpoint698} {
        font-size: 12.5px;
        height: 40px;
        width: 125px;
      }

      @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1440} and ${deviceHeight.breakpoint798} {
        font-size: 13.5px;
        height: 43px;
        width: 158px;
        max-width: 158px;
      }
    }
    // Media breakpoints for kuda-header--wrap
    @media only screen and ${deviceMaxWidth.breakpoint320} {
      padding-left: 14px;
      padding-right: 14px;
      flex-direction: column;
      align-items: start !important;
    }

    @media only screen and ${deviceMaxWidth.breakpoint767} {
      padding-left: 20px;
      padding-right: 20px;
    }
    @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1024} {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  .kuda-header--actions {
    position: relative;
    display: flex;
    align-items: center;

    .kuda-cta {
      font-weight: 700;
      font-size: 16px;
      line-height: 1;
      display: flex;
      align-items: center;
      padding: 15px 15px;
      border-radius: 4px;
      justify-content: center;
      cursor: pointer;
      --primaryColor: #000000;
      background: #000000;
      border-radius: 10px;
      color: #ffffff;
      height: 48px;
      transition: transform 0.6s;

      &:hover {
        transform: translate3d(0px, -3px, 0px);
      }

      @media only screen and ${deviceMaxWidth.breakpoint350} {
        font-size: 13px;
        height: 42px;
        width: 100%;
      }

      @media only screen and (max-width: 320px) {
        max-width: 100%;
      }
      @media only screen and (max-width: 320px) {
        font-size: 12px;
        width: 131px;
        margin-top: 15px;
      }
      @media only screen and (max-width: 375px) {
        font-size: 13px;
        width: 140px;
      }
      @media only screen and (max-width: 767px) {
        font-size: 14px;
        height: 42px;
        width: 150px;
      }
    }

    .kuda-cta-primary-light {
      color: #000000;
      background: #F4F4F4;
    }

    .kuda-cta-lg {
      //   max-width: 152px;
      width: 100%;
    }

    /* Media queries for kuda-header--actions */
    @media only screen and (max-width: 320px) {
      position: static;
    }
    @media only screen and (max-width: 320px) {
      width: 100%;
    }
  }
  /* Media queries for kuda-header */
  @media only screen and ${deviceHeight.breakpoint800} and ${deviceMinWidth.breakpoint1025} and ${deviceMinWidth.breakpoint1366} {
    padding: 48px 40px 60px;
  }

  @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1280} and ${deviceHeight.breakpoint698} {
    height: 58px;
  }
  @media only screen and ${deviceMinWidth.breakpoint768} and ${deviceMaxWidth.breakpoint1440} and ${deviceHeight.breakpoint798} {
    height: 65px;
  }
  @media only screen and ${deviceMaxWidth.breakpoint767} {
    height: 64px;
  }
  @media only screen and ${deviceMaxWidth.breakpoint320} {
    height: 110px;
  }
`;
